export default __webpack_public_path__ + "static/media/invite-baner.ceff81fb.svg";